<template>
    <div>
        <!-- Header -->
        <div class="header py-7 py-lg-8 pt-lg-9" :class="themeClass">
            <div class="container">
                <div class="header-body text-center mb-6">
                    <div class="row justify-content-center">
                        <div class="col-xl-5 col-lg-6 col-md-8 px-5">
                            <h1 class="text-white">{{ $t('brand.login-title') }}</h1>
                            <p class="text-lead text-white">{{ $t('brand.login-description') }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
                    xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>

        <!-- Page content -->
        <div class="container mt--8 pb-5">
            <div class="row justify-content-center">
                <div class="col-lg-5 col-md-7">
                    <login-card></login-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LoginCard from './components/LoginCard'

    export default {

        components: {
            LoginCard
        },
        
        computed: {
            themeClass() {
                let color = window.socratesTheme == 'blue' ? 'info' : window.socratesTheme
                return 'bg-gradient-' + color
            }
        }
    }
</script>
